import {
  Component,
  LOCALE_ID,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import * as screenfull from 'screenfull';
import { HydratedTchek } from '../model/tchekb.model';
import { TchekListComponent } from '../element/tchek-list/tchek-list.component';
import { SearchService } from '../service/search.service';
import { TchekService, GetTchekOpts } from '../service/tchek.service';
import 'parse';
const parse: typeof Parse = require('parse');

declare var cv: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit {
  onSearch: boolean = false;
  resultTchek: boolean = true;
  home: boolean = true
  isFull: boolean;
  count: number;
  unreadCount: number;
  isSearching: boolean;
  numberTchek: number;
  isSuperAdmin = false;
  @ViewChild(TchekListComponent) tchekList: TchekListComponent;

  getTchekOptions = {
    limit: 10,
    includeThumbnail: true,
    sort: 'latest'
  } as GetTchekOpts;


  constructor(
    private readonly _tchekService: TchekService,
    @Inject(LOCALE_ID) protected localeId: string,
    private readonly _searchService: SearchService
  ) {
    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');
    this.isFull = screenfull.isFullscreen;
    this.isSearching = false;
  }

  tchekAddedObserver(tchek: HydratedTchek) {
    this.numberTchek++;
  }

  ngOnInit() {
    const observablesPair = this._tchekService.subscribeTcheks(this.getTchekOptions);
    observablesPair.plusOneObservable.subscribe(this.tchekAddedObserver.bind(this));

	if ( !this._tchekService.unreadCount){
		this._tchekService.countUnread()
		.then(count => {
			this._tchekService.unreadCount = count  
			this.unreadCount = this._tchekService.unreadCount
		if (count === 0 ){
			this._tchekService.countTcheks().then(number => { this.numberTchek = number })
		}
		});
	}
	this.unreadCount = this._tchekService.unreadCount
    this._tchekService
      .subscribeUnreadCount(() => {this.unreadCount++
	this._searchService.lastFinderData = undefined
}, () => this.unreadCount--);
  }

  handleSearchLoading(data) {
    console.log(">>> handleSearchLoading()",data);
    if (!data) this.resultTchek = false;
    this.tchekList.loading = data.loading;
    this.isSearching = data.isSearching;
    this.count = data.count;
    this.home = false
    if (data.home) {
      this.home = true
    }
  }

  handleSearchResults(tcheks: HydratedTchek[]) {
    this.tchekList.tcheks = tcheks;
    //console.log(">>> handleSearchResults() : start",this.count, this.numberTchek, this._searchService.finderData.skip, this.resultTchek, this.onSearch);
    if (this.count !== undefined) {
      if (this.count > this._searchService.finderData.skip) 
        this.resultTchek = true;
      else 
        this.resultTchek = false;
    }
    if (this.onSearch === true)
      this.onSearch = false;
    //console.log(">>> handleSearchResults() : end",this.count, this.numberTchek, this._searchService.finderData.skip, this.resultTchek, this.onSearch);
  }

  addTcheks() {
    console.log(">>> addTcheks");
    this.onSearch = true;
    this._searchService.readMoreF()
  }

  toggleFullScreen() {
    const doc = window.document as any;
    const docEl = doc.documentElement as any;

    const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullscreen;
    const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitCancelFullScreen;

    if (doc.fullscreenElement || doc.mozFullScreen || doc.webkitIsFullScreen) {
      cancelFullScreen.call(doc);
    } else {
      requestFullScreen.call(docEl);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts